import React from 'react';

import './css/CustomInput.css';

// FIXME: Propsの型定義
export const CustomInput: React.ForwardRefExoticComponent<any> =
  React.forwardRef(({ value, onClick }, ref: React.Ref<any>) => (
    <div
      data-test="date-picker-custom-input"
      className="custom-date-input-field"
      onClick={onClick}
      ref={ref}
    >
      {value}
    </div>
  ));
